<div>
  <app-loading-spinner *ngIf="isLoading"></app-loading-spinner>
  <canvas #chartEl style="height: 300px"></canvas>
</div>
